import React, { useState, useEffect, useRef } from "react";
import "./TodoForm.css";

export default function TodoForm({ categories, defaultCategoryId, onSubmit }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState("medium");
  const [categoryId, setCategoryId] = useState(defaultCategoryId || "");
  const [dueDate, setDueDate] = useState("");
  const [dueTime, setDueTime] = useState("");
  const titleRef = useRef(null);

  // Sync category selection when the active category view changes
  useEffect(() => {
    setCategoryId(defaultCategoryId || "");
  }, [defaultCategoryId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    await onSubmit({
      title: title.trim(),
      description: description.trim(),
      priority,
      category_id: categoryId ? parseInt(categoryId) : null,
      due_date: dueDate || null,
      due_time: dueTime || null,
    });
    setTitle("");
    setDescription("");
    setPriority("medium");
    setDueDate("");
    setDueTime("");
    titleRef.current?.focus();
  };

  return (
    <form className="add-form" onSubmit={handleSubmit}>
      <div className="add-form-row">
        <input
          ref={titleRef}
          type="text"
          placeholder="What needs to be done?"
          value={title}
          onChange={e => setTitle(e.target.value)}
          autoComplete="off"
        />
        <button type="submit" className="btn-add">Add</button>
      </div>
      <div className="add-form-extras">
        <input
          type="text"
          placeholder="Description (optional)"
          value={description}
          onChange={e => setDescription(e.target.value)}
        />
        <select className="form-select" value={priority} onChange={e => setPriority(e.target.value)}>
          <option value="low">Low</option>
          <option value="medium">Medium</option>
          <option value="high">High</option>
        </select>
        <label className="form-date-label">
          <span className="form-date-hint">Date</span>
          <input
            type="date"
            className="form-select"
            value={dueDate}
            onChange={e => setDueDate(e.target.value)}
          />
        </label>
        <label className="form-date-label">
          <span className="form-date-hint">Time</span>
          <input
            type="time"
            className="form-select"
            value={dueTime}
            onChange={e => setDueTime(e.target.value)}
            disabled={!dueDate}
          />
        </label>
        <select className="form-select" value={categoryId} onChange={e => setCategoryId(e.target.value)}>
          <option value="">No category</option>
          {categories.filter(c => !c.parent_id).map(parent => {
            const children = categories.filter(c => c.parent_id === parent.id);
            if (children.length === 0) {
              return <option key={parent.id} value={parent.id}>{parent.name}</option>;
            }
            return (
              <optgroup key={parent.id} label={parent.name}>
                <option value={parent.id}>{parent.name} (all)</option>
                {children.map(c => (
                  <option key={c.id} value={c.id}>— {c.name}</option>
                ))}
              </optgroup>
            );
          })}
        </select>
      </div>
    </form>
  );
}
